var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgHubspotIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 13,
    viewBox: "0 0 25 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7A59",
    d: "M19.068 8.56V5.466a2.384 2.384 0 001.375-2.15v-.07A2.384 2.384 0 0018.06.86h-.071a2.384 2.384 0 00-2.384 2.384v.072c.004.922.54 1.758 1.374 2.149V8.56a6.752 6.752 0 00-3.21 1.413L5.277 3.36c.06-.218.092-.443.095-.669a2.686 2.686 0 10-2.689 2.681c.465-.002.92-.126 1.322-.359l8.362 6.506a6.773 6.773 0 00.104 7.629l-2.543 2.543c-.206-.066-.42-.1-.636-.103a2.206 2.206 0 102.208 2.207 2.178 2.178 0 00-.104-.635l2.516-2.516A6.784 6.784 0 1019.068 8.56m-1.042 10.182a3.48 3.48 0 110-6.959 3.48 3.48 0 01.003 6.957"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspotIcon);
export default ForwardRef;